<template>

    <div v-if="text" class="collapsible-text--container">
        <div @click="textCollapse" class="collapsible-text__header js-text-section">
            <i class="fas fa-plus-circle"></i>
            <p class="body-1"><slot name='heading'></slot></p>
        </div>
        <p class="collapsible-text__body body-1">
            <slot name='body'></slot>
        </p>
    </div>

    <section v-else-if="accordion" class="accordion__section">
        <div @click="accordionCollapse" class="section__header js-accordion">
            <h4><slot name='heading'></slot></h4>
            <i class="far fa-plus-square"></i>
        </div>
        <div class="section__body">
            <slot name='body'></slot>
        </div>
    </section>

    <section v-else-if="collapse" class="section--container">
        <div @click="sectionCollpase" class="section__header js-section">
            <h4><slot name='heading'></slot></h4>
            <i class="far fa-plus-square"></i>
        </div>
        <div class="section__body">
            <slot name='body'></slot>
        </div>
    </section>

    <section v-else class="section--container">
        <div :class="classes" class="section__header">
            <h4><slot name='heading'></slot></h4>
        </div>
        <div class="section__body open">
            <slot name='body'></slot>
        </div>
    </section>
    
</template>

<script>
export default {
    props: {
        accordion: { type: Boolean, default: false },
        text: { type: Boolean, default: false },
        collapse: { type: Boolean, default: false },
        color: { type: String, default: 'blue' }
    },
    methods: {
        sectionCollpase(e) {
            let el = e.target

            if (!e.target.classList.contains('js-section')) {
                el = e.target.closest('.js-section');
            }

            el.querySelector('i').classList.toggle('fa-plus-square');
            el.querySelector('i').classList.toggle('fa-minus-square');
            el.nextElementSibling.classList.toggle('open');
        },
        textCollapse(e) {
            let el = e.target

            if (!e.target.classList.contains('js-text-section')) {
                el = e.target.closest('.js-text-section');
            }

            el.querySelector('i').classList.toggle('fa-plus-circle');
            el.querySelector('i').classList.toggle('fa-minus-circle');
            el.nextElementSibling.classList.toggle('open');
        },
        accordionCollapse(e){
            const container = e.target.closest('.accordion--container').id;
            const icon = e.target.closest('.js-accordion').querySelector('i')
            const body = e.target.closest('.js-accordion').nextElementSibling;

            if (icon.classList.contains('fa-minus-square') && body.classList.contains('open')) {
                icon.classList.replace('fa-minus-square', 'fa-plus-square');
                body.classList.remove('open');
            } else {
                let accordion = document.getElementById(container)

                accordion.querySelectorAll('i').forEach((icon) => {
                    icon.classList.replace('fa-minus-square', 'fa-plus-square');
                })

                accordion.querySelectorAll('.section__body').forEach((body) => {
                    body.classList.remove('open');
                })

                icon.classList.replace('fa-plus-square', 'fa-minus-square');
                body.classList.add('open');
            }
        }
    },
    computed: {
        classes () {
            const { color } = this
            
            return [
                ...(color ? [`${color}`] : null),
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.red{
    &:before{
        border-top-color: #E33D25;
    }
}
.green{
    &:before{
        border-top-color: #58A546;
    }
}
.yellow{
    &:before{
        border-top-color: #EDCB18;
    }
}
</style>